exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#bv-modal-cloud-delete .modal-content,#bv-modal-cloud-delete .modal-dialog,#bv-modal-costi-delete .modal-content,#bv-modal-costi-delete .modal-dialog,#bv-modal-documenti-delete .modal-content,#bv-modal-documenti-delete .modal-dialog,#bv-modal-note-delete .modal-content,#bv-modal-note-delete .modal-dialog{max-width:32em}", ""]);

// exports
